import React from 'react';
import * as _Builtin from './_Builtin';
import * as _utils from './utils';
import _styles from './DevlinkSkuCategorySelectSection.module.css';

export function DevlinkSkuCategorySelectSection({
  as: _Component = _Builtin.Section,
  sectionTitle = 'How can we help?',
  subtext = 'In-home service from 7am-9pm. Book online or by phone in minutes for service as soon as today.',
  categoryMenu,
}) {
  return (
    <_Component
      className={_utils.cx(_styles, 'position-relative')}
      grid={{
        type: 'section',
      }}
      tag="section"
    >
      <_Builtin.Block className={_utils.cx(_styles, 'bg-secondary700')} tag="div">
        <_Builtin.Block className={_utils.cx(_styles, 'huge')} tag="div" />
        <_Builtin.Block className={_utils.cx(_styles, 'ht-container', 'lg')} tag="div">
          <_Builtin.Block className={_utils.cx(_styles, 'ht-contained-hero-centered')} tag="div">
            <_Builtin.Block className={_utils.cx(_styles, 'ht-contained-hero-content')} tag="div">
              <_Builtin.Block className={_utils.cx(_styles, 'ht-hero-content', 'center')} tag="div">
                <_Builtin.Block className={_utils.cx(_styles, 'txt-n000')} tag="div">
                  <_Builtin.Heading className={_utils.cx(_styles, 'txt-title', 'txt-n000')} tag="h2">
                    {sectionTitle}
                  </_Builtin.Heading>
                  <_Builtin.Block className={_utils.cx(_styles, 'small')} tag="div" />
                  <_Builtin.Paragraph className={_utils.cx(_styles, 'txt-body-md', 'txt-n000')}>{subtext}</_Builtin.Paragraph>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block className={_utils.cx(_styles, 'medium')} tag="div" />
          <_Builtin.Block className={_utils.cx(_styles, 'ht-category-select-grid')} tag="div">
            {categoryMenu}
          </_Builtin.Block>
        </_Builtin.Block>
        <_Builtin.Block className={_utils.cx(_styles, 'huge')} tag="div" />
      </_Builtin.Block>
      <_Builtin.Block className={_utils.cx(_styles, 'ht-bg-fill-container')} tag="div">
        <_Builtin.Image
          className={_utils.cx(_styles, 'ht-homepage-cat-nav-blob')}
          loading="lazy"
          width="auto"
          height="auto"
          alt=""
          src="https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/6604a9049660b46d146767ff_homepage-hero-bg-blob.svg"
        />
      </_Builtin.Block>
    </_Component>
  );
}
